/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendAdvancedProductDto } from '../../models/backend-advanced-product-dto';

export interface SalesAdvancedProductsRetrieve$Params {
  id: number;
}

export function salesAdvancedProductsRetrieve(
  http: HttpClient,
  rootUrl: string,
  params: SalesAdvancedProductsRetrieve$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendAdvancedProductDto>> {
  const rb = new RequestBuilder(rootUrl, salesAdvancedProductsRetrieve.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendAdvancedProductDto>;
    }),
  );
}

salesAdvancedProductsRetrieve.PATH = '/api/sales/advanced-products/{id}/';
